var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGird = function SvgGird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gird_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 62h300v300H62V62zm0 600h300v300H62V662zM662 62h300v300H662V62zm0 600h300v300H662V662z"
  })));
};

export default SvgGird;